import styled from 'styled-components';

export const $MultiBanners = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  & > *:last-child {
    margin-bottom: 1rem;
  }
`;
